import { refreshAccessToken } from "../api/apiClient";
import { User } from "../types/slice.types";
import { login, setAuthCompleted } from "../redux/slices/authSlice";
import { Dispatch } from "redux";

export const initApi = async (dispatch: Dispatch<any>, user: User) => {
  if (localStorage.getItem("token") && !user?.email) {
    const loginDetails = await refreshAccessToken();
    if (loginDetails?.ok) {
      dispatch(login({ user: loginDetails.user, token: loginDetails.token }));
    }
  }
  dispatch(setAuthCompleted());
};
